import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  ElementRef,
  EventEmitter,
  forwardRef,
  input,
  Input,
  Output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'app-tree-select',
  templateUrl: './tree-select.component.html',
  styleUrl: './tree-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TreeSelectComponent)
    }
  ],
  standalone: false
})
export class TreeSelectComponent implements ControlValueAccessor {
  @Input() filter: boolean = false;
  @Input() lazy: boolean = false;
  @Input() filterBy: string = 'value';
  @Input() optionLabel: string;

  options = input<any[]>([]);

  treeOptions = computed(() => {
    const filteredOptions = this.options()?.filter((item) => !!item);

    if (filteredOptions) {
      return JSON.parse(JSON.stringify(filteredOptions));
    }
    return [];
  });

  @Input() placeholder: string = '';
  @Input() id: string;
  @Input() name: string;
  @Input() class: string;
  @Input() styleClass: string;
  @Input() selectionMode: 'checkbox' | 'single' = 'single';
  @Input() appendTo: string = 'body';
  @Input() disabled: boolean;
  @Input() ngModelOptions: { [key: string]: unknown };
  @Input() emptyMessage: string;

  @Output() unSelectItem = new EventEmitter<unknown>();
  @Output() handleFilter? = new EventEmitter<unknown>();
  @Output() handleFocus? = new EventEmitter<unknown>();
  @Output() handleHide? = new EventEmitter<unknown>();

  value: unknown;

  onModelChange = (value: unknown) => value;
  onModelTouched = () => {};

  constructor(
    public el: ElementRef,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  writeValue(value: unknown): void {
    this.value = value;
    this.changeDetectorRef.markForCheck();
  }

  registerOnChange(onChange: (value: unknown) => unknown): void {
    this.onModelChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onModelTouched = onTouched;
  }

  markAsTouched() {
    this.onModelTouched();
  }

  onChange(value: TreeNode) {
    delete value?.parent;
    this.onModelChange(value);
  }

  onUnselectItem(event: MouseEvent, selectedItem: unknown) {
    event.stopPropagation();
    this.unSelectItem.emit(selectedItem);
  }
}
